<template>
  <div>
    <h6 class="my-4 font-weight-bold">Twoje zamówienia</h6>
    <div v-if="loading" class="text-center my-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else-if="!loading && allOrders.length > 0">
      <b-table
        striped
        hover
        :items="allOrders"
        :fields="fields"
        :current-page="page"
      >
        <template #cell(Id)="data">
          {{ data.item.id }}
        </template>
        <template #cell(lp)="data">
          {{ (page - 1) * per_page + data.index + 1 }}
        </template>
        <template #cell(typeName)="data">
          <router-link
            v-if="data.item.type === 'aktu'"
            :to="{
              name: 'ShowOsOrder',
              params: {
                year: data.item.year,
                id: data.item.id,
                previousPage: page,
              },
            }"
            >{{ data.item.typeName }}
          </router-link>
          <router-link
            v-else
            :to="{
              name: 'ShowOrder',
              params: { id: data.item.id, previousPage: page },
            }"
            v-html="cloudName(data.item.typeName)"
          ></router-link>
        </template>
        <template #cell(invoice)="data">
          <span v-if="data.item.invoice"
            ><a :href="data.item.invoice"
              >Pobierz Fakturę VAT <i class="fas fa-file-invoice py-0"></i
              ><span v-if="!data.item.invoiceRead" class="text-danger ml-2"
                ><i class="fas fa-exclamation"></i></span></a></span
          ><br v-if="data.item.invoice && data.item.proformaInvoice" />
          <span v-if="data.item.proformaInvoice"
            ><a :href="data.item.proformaInvoice"
              >Pobierz Fakturę Pro forma
              <i class="fas fa-file-invoice py-0"></i></a
          ></span>
        </template>
      </b-table>
      <b-pagination
        v-model="page"
        :total-rows="total"
        :per-page="per_page"
        aria-controls="my-table"
        align="center"
        first-number
        last-number
      ></b-pagination>
    </div>
    <div v-else>Brak zamówień</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'History',
  data() {
    return {
      allOrders: [],
      fields: [
        'lp',
        { key: 'Id', label: 'Nr' },
        { key: 'typeName', label: 'Temat' },
        { key: 'date', label: 'Data' },
        { key: 'status', label: 'Status' },
        { key: 'invoice', label: 'Do pobrania' },
        { key: 'notes', label: 'Uwagi' },
      ],
      page: 0,
      total: null,
      per_page: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      client: 'auth/client',
    }),
    rows() {
      return this.allOrders.length;
    },
  },
  created() {
    this.$store.dispatch('auth/me');
    this.$store.commit('order/resetOrder');
    this.$store.commit('order/resetSteps');
    this.getOrders();
  },
  methods: {
    getOrders() {
      let page = this.page !== 0 ? this.page : this.$route.params.previousPage;
      this.loading = true;

      axios
        .get(
          '/api/getOrdersHistory/' +
            this.program +
            '/' +
            this.licence +
            '?page=' +
            page
        )
        .then(({ data }) => {
          this.allOrders = data.data;
          this.page = data.meta.current_page;
          this.total = data.meta.total;
          this.per_page = data.meta.per_page;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 419) {
            this.$store.dispatch('auth/me');
            this.$router.push({ name: 'Login' });
          }
        });
    },
    cloudName(name) {
      if (name === 'Chmura') {
        return this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('B')
          ? this.program.toUpperCase() + '24 Connect Biuro'
          : this.program === 'skp'
          ? 'SKP24 Connect Firma'
          : 'SAM<sup>®</sup> Firma w Chmurze';
      }

      return name;
    },
  },
  watch: {
    page(newValue, oldValue) {
      this.getOrders();
    },
  },
};
</script>

<style scoped></style>
